import { Enum } from './Enum';

export class BiannualStatus extends Enum {
  translationKey = 'biannualStatus';

  static asArray: BiannualStatus[] = [];

  static byKey: { [name: string]: BiannualStatus } = {};

  static readonly DUE = new BiannualStatus('DUE');

  static readonly OVERDUE = new BiannualStatus('OVERDUE');

  static toSelectable() {
    return Enum.toSelectable(BiannualStatus.asArray);
  }

  constructor(public readonly value: string) {
    super();
    BiannualStatus.asArray.push(this);
    BiannualStatus.byKey[value] = this;
  }
}

export default BiannualStatus;
